(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("morningstar"), require("handlebars/runtime"));
	else if(typeof define === 'function' && define.amd)
		define("markets-components-minichart", ["morningstar", "handlebars.runtime"], factory);
	else if(typeof exports === 'object')
		exports["markets-components-minichart"] = factory(require("morningstar"), require("handlebars/runtime"));
	else
		root["markets-components-minichart"] = factory(root["morningstar"], root["Handlebars"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_11__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(morningstar) {
	    'use strict';
	    var QSAPI = morningstar.components['markets-components-core'];
	    //require("./style/minichart.scss");
	    return QSAPI.components.register('minichart', __webpack_require__(2));
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(3)], __WEBPACK_AMD_DEFINE_RESULT__ = function(miniChart) {
	    'use strict';
	
	    function init(container, component) {
	        var instance = new miniChart(container, component.configuration, component.callbacks);
	        //here, we need add code to initlize the component
	        return instance;
	    }
	    return {
	        init: init,
	        properties: {
	            needTrack: true,
	            setter: {
	                "parentSize": "changeOutSize",
	                "investment": "changeMainTicker",
	                "skin": "changeSkin"
	            },
	            getter: {},
	            events: {
	                'load': 'onLoad',
	                'error': 'onError',
	                'configChange':'onConfigChange',
	                'tickerAccepted': 'onTickerAccepted'
	            }
	        }
	    };
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(4), __webpack_require__(5), __webpack_require__(9), __webpack_require__(8), __webpack_require__(12), __webpack_require__(13)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, defConfig, chart, legend, labels, minichartHtml, footerHtml) {
	        'use strict';
	        var QSAPI = morningstar.components['markets-components-core'];
	        var $ = QSAPI.$;
	        var Util = QSAPI.Util;
	        var config = defConfig;
	        var miniChartComponent = function (container, option, callbacks) {
	            config = $.extend(true, config, option);
	            this.id = 'minichart_unique_id_' + Util.IdProducer.getId();
	            this.$outerContainer = (container.jQuery) ? container : $(container);
	            this.$plotContainer = null;
	            this.legendContainer = null;
	            this.breakpointStatus = Infinity;
	            this.cb = $.extend(true, {}, callbacks);
	            this.render();
	        };
	
	        miniChartComponent.prototype = {
	            render: function () {
	                this.$container = $(minichartHtml({
	                    skin: config.skin
	                })).appendTo(this.$outerContainer);
	                this.$plotContainer = this.$container.find(".markets-components-minichart-plot-container");
	                this.$legendContainer = this.$container.find(".markets-components-minichart-legend-container");
	                this.$footer = this.$container.find(".markets-components-minichart-footer");
	                this.$loading = this.$container.find(".markets-components-minichart-loading");
	                var chartWidth, chartHeight, legendHeight;
	                var isMobileSize = this.$container.width() <= config.breakpointArray[0];
	                var containerHeight = Math.max(this.$container.height(), config.minHeight);
	
	                legendHeight = (isMobileSize) ? "auto" : containerHeight - (config.xaxis.height + config.xaxis.marginTop) - this.$footer.outerHeight(true);
	                this.legend = new legend(this.$legendContainer, {
	                    height: legendHeight,
	                    locale: config.locale,
	                    currencySymbol: config.currencySymbol
	                });
	                var chartHeight = containerHeight - this.$footer.outerHeight(true);
	                chartHeight = Math.max(chartHeight, 30);
	                this.$plotContainer.height(chartHeight);
	                var legendWidth = this.$legendContainer.outerWidth(true);
	                var containerWidth = this.$container.outerWidth(true);
	                var _containerWidth = containerWidth > legendWidth ? containerWidth : config.minWidth;
	                chartWidth = (isMobileSize) ? _containerWidth : (_containerWidth - legendWidth);
	                var self = this;
	                this.minichart = new chart(this.$plotContainer, $.extend(true, {}, config, {
	                    width: chartWidth,
	                    height: chartHeight
	                }), {
	                    onDrawEnd: function (data) {
	                        self.setLastPrice(data);
	                        self.renderFooter(data);
	                    },
	                    onLoad: function () {
	                        self._execCallBack("onLoad");
	                        self.changeOutSize();
	                        self.hideLoading();
	                    },
	                    onNodata: function () {
	                        self.setLastPrice({
	                            currencySymbol: '--',
	                            currencyCode: '--',
	                            lastClosePrice: '--'
	                        });
	                        self.renderFooter({
	                            currency: '--',
	                            exchangeName: '--',
	                            endDate: '--'
	                        });
	                    },
	                    onMainTickerChanged: function (tickerObject) {
	                        self._execCallBack("onConfigChange", {
	                            saveConfig: {
	                                mainTicker: Util.getSavedTicker(tickerObject)
	                            }
	                        });
	                    },
	                    onTickerAccepted: function (tickerObject) {
	                        self._execCallBack("onTickerAccepted", Util.getSecurityInfo(tickerObject));
	                    }
	                });
	            },
	            setLastPrice: function (data) {
	                var c = config.currency === 'code' ? data.currencyCode + ' ' : data.currencySymbol;
	                this.legend.setData(c + data.lastClosePrice);
	            },
	            destroy: function () {
	                this.minichart.unregisterChartTickers();
	                this.minichart.svgplot && this.minichart.svgplot.destroy();
	                this.minichart.svgplot = null;
	                this.$container.remove();
	            },
	            renderFooter: function (data) {
	                var renderData = {
	                    currency: data.currencyCode,
	                    exchange: data.exchangeName,
	                    date: data.endDate,
	                    label: labels.getLabel(config.locale, "endofdate")
	                }
	                this.$footer.html(footerHtml(renderData));
	            },
	            showLoading: function () {
	                this.$loading.show();
	            },
	            hideLoading: function () {
	                this.$loading.hide();
	            },
	            changeMainTicker: function (ticker) {
	                this.showLoading();
	                this.minichart.changeMainTicker(ticker);
	            },
	            changeSkin: function (theme) {
	                var str = 'markets-components-minichart--';
	                var themeClass = str + config.skin;
	                if (this.$container.hasClass(themeClass)) {
	                    this.$container.removeClass(themeClass);
	                }
	                themeClass = str + theme;
	                config.skin = theme;
	                this.$container.addClass(themeClass);
	            },
	            changeOutSize: function (w, h) {
	                var width = w || this.$container.width();
	                var height = h || this.$container.height();
	                this.$container.width(width);
	                if (width < config.minWidth) {
	                    width = config.minWidth;
	                    height = height - this._getScrollBarInfo().width;
	                    this.$container.css('overflow-x', 'auto');
	                } else {
	                    this.$container.css('overflow-x', 'visible');
	                }
	                if (height < config.minHeight) {
	                    height = config.minHeight;
	                    width = width - this._getScrollBarInfo().width;
	                    this.$container.css('overflow-y', 'auto');
	                } else {
	                    this.$container.css('overflow-y', 'visible');
	                }
	
	                this.addOrRemoveBreakPointStyle(width);
	                var chartWidth = width - (this.$legendContainer.outerWidth(true) + 1);
	                var chartHeight = height - this.$footer.outerHeight(true);
	                var isMobileSize = (width <= config.breakpointArray[0]);
	                if (isMobileSize) {
	                    chartWidth = width;
	                    this.$legendContainer.height("auto");
	                    chartHeight = chartHeight - this.$legendContainer.outerHeight(true);
	                } else {
	                    this.$legendContainer.height(height - (config.xaxis.height + config.xaxis.marginTop) - this.$footer.outerHeight(true));
	                }
	                chartWidth > 0 && this.$plotContainer.width(chartWidth);
	                chartHeight > 0 && this.$plotContainer.height(chartHeight);
	                this.minichart && this.minichart.resize(chartWidth);
	
	            },
	            _getScrollBarInfo: function () {
	                var scrollBarHelper = document.createElement("div");
	                scrollBarHelper.style.cssText = "overflow:scroll;width:100px;height:100px;";
	                document.body.appendChild(scrollBarHelper);
	                var __scrollBarInfo = {};
	                if (scrollBarHelper) {
	                    __scrollBarInfo = {
	                        height: scrollBarHelper.offsetHeight - scrollBarHelper.clientHeight,
	                        width: scrollBarHelper.offsetWidth - scrollBarHelper.clientWidth
	                    };
	                }
	                document.body.removeChild(scrollBarHelper);
	                return __scrollBarInfo;
	            },
	            _execCallBack: function (name, args) {
	                if ($.isFunction(this.cb[name])) {
	                    args = args || {};
	                    this.cb[name].call(this, args);
	                }
	            },
	            addOrRemoveBreakPointStyle: function (width) {
	                var self = this;
	                var prefix = "markets-components-minichart-";
	                var suffix = "style";
	                var lastStatus = self.breakpointStatus;
	                var bpArray = config.breakpointArray;
	                var bpLength = bpArray.length;
	                for (var i = bpLength; i > 0; i--) {
	                    if (width > bpArray[i - 1]) {
	                        break;
	                    }
	                };
	                self.breakpointStatus = i;
	                if (lastStatus > self.breakpointStatus) {
	                    for (var k = self.breakpointStatus; k < lastStatus && k < bpLength; k++) {
	                        self.$container.addClass(prefix + 'w' + bpArray[k] + suffix);
	                    }
	                } else if (lastStatus < self.breakpointStatus) {
	                    for (var k = lastStatus; k < self.breakpointStatus && k < bpLength; k++) {
	                        self.$container.removeClass(prefix + 'w' + bpArray[k] + suffix);
	                    }
	                }
	            },
	        };
	        return miniChartComponent;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
	    var config = {
	        locale: 'en-US',
	        breakpointArray: [400],
	        mainTicker: '0P000002RH',
	        compareTickers: [],
	        frequency: "d",
	        minHeight: 180,
	        minWidth: 300,
	        dateRange: [],
	        interval: '3M',
	        currencyCode: '',
	        currencySymbol: '',
	        skin: 'default',
	        currency: 'code', //symbol:$, code:USD
	        updateLastAccessTime: true, //control chart loop call. true: update session; false: failed session change.
	        chartStyle: 'line',
	        dot: {
	            radius: 3,
	            style: {
	                fill: '#006098'
	            }
	        },
	        line: {
	            style: {
	                'stroke': '#006098',
	                'stroke-width': '2px',
	                'stroke-dasharray': 'none'
	            }
	        },
	        highlight: {
	            show: false,
	        },
	        yaxis: {
	            width: 40,
	            align: 'right',
	            orient: 'right',
	            maxTickCount: 5,
	            decimal: 2,
	            numberFormat: null,
	            tick: {
	                line: {
	                    show: true,
	                    spacing: 12,
	                    style: {
	                        top: {
	                            'stroke': '#999999',
	                            'stroke-width': '1px'
	                        },
	                        middle: {
	                            'stroke': '#DDDDDD',
	                            'stroke-width': '1px'
	                        },
	                        bottom: {
	                            'stroke': '#999999',
	                            'stroke-width': '1px'
	                        }
	                    }
	                },
	                text: {
	                    style: {
	                        "font-family": "UniversLight, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif",
	                        "font-weight": "400",
	                        "color": "#151515",
	                        "line-height": "17px",
	                        "font-size": "14px",
	                        "transform": "translate(0px,1px)"
	                    }
	                }
	            },
	
	        },
	        xaxis: {
	            height: 20,
	            marginTop: 4,
	            indicateYear: true,
	            tick: {
	                text: {
	                    style: {
	                        "font-family": "UniversLight, HelveticaNeue, Helvetica Neue, Helvetica, Arial, sans-serif",
	                        "font-weight": "400",
	                        "color": "#151515",
	                        "line-height": "17px",
	                        "font-size": "14px"
	                    }
	                }
	            }
	        },
	        gridlines: {
	            yLine: {
	                show: true,
	                style: {
	                    top: {
	                        'stroke': '#999999',
	                        'stroke-dasharray': 'none',
	                        'stroke-width': '1px'
	                    },
	                    middle: {
	                        'stroke': '#DDDDDD',
	                        'stroke-dasharray': 'none',
	                        'stroke-width': '1px'
	                    },
	                    bottom: {
	                        'stroke': '#999999',
	                        'stroke-dasharray': 'none',
	                        'stroke-width': '1px'
	                    }
	                }
	            },
	            xRect: {
	                show: true,
	                oddStyle: {
	                    fill: "#F9F9F9"
	                }
	            },
	            xLine: {
	                show: false
	            }
	        },
	        isWithMUIPrefix: true
	    };
	    return config;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(6), __webpack_require__(7), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function (morningstar, dataAdapterModel, common, labels) {
	        'use strict';
	        var QSAPI = morningstar.components['markets-components-core'];
	        var $ = QSAPI.$;
	        var Util = QSAPI.Util;
	        var dateUtil = QSAPI.Widget.Chart.Util;
	        var chartDataManager = QSAPI.DataManager.Chart;
	        var dataAdapter = dataAdapterModel();
	        var ChartType = common.chartType;
	        var PriceType = common.priceType;
	        var numberFormat;
	
	        function debounce(func, wait, immediate) {
	            var timeout;
	            return function () {
	                var context = this,
	                    args = arguments;
	                var later = function () {
	                    timeout = null;
	                    if (!immediate) func.apply(context, args);
	                };
	                var callNow = immediate && !timeout;
	                clearTimeout(timeout);
	                timeout = setTimeout(later, wait);
	                if (callNow) func.apply(context, args);
	            };
	        }
	        var chart = function (container, config, callbacks) {
	            var self = this
	            self.$container = (container.jQuery) ? container : $(container);
	            config.needTrack = false;
	            self.config = config;
	            self.cb = $.extend(true, {}, callbacks);
	            self.mainTicker = config.mainTicker
	            self.compareTickers = config.compareTickers;
	            self.mainTickerObject = null;
	            self.seriesList = [];
	            numberFormat = new Intl.NumberFormat(config.locale || 'en-US', {
	                style: 'decimal',
	                minimumFractionDigits: config.yaxis.decimal,
	                maximumFractionDigits: config.yaxis.decimal
	            }).format;
	            self.chartObj = {
	                id: 'markets-components-minichart-' + Date.now(),
	                refreshChart: function () {
	                    self.seriesList = [];
	                    self.init();
	                }
	            };
	            self.init();
	            self.changeMainTicker = debounce(this._changeMainTicker, 500, true);
	        };
	
	        chart.prototype = {
	            init: function (triggerMainTickerChange) {
	                var self = this;
	                var tickerCollection = [this.mainTicker].concat(this.compareTickers);
	                dataAdapter.init();
	                dataAdapter.createTickerObjects(tickerCollection).done(function (tickerObjects) {
	                    if (tickerObjects[0].symbol !== self.mainTicker) {
	                        return;
	                    }
	                    tickerObjects[0].updateLastAccessTime = self.config.updateLastAccessTime;
	                    self.mainTickerObject = tickerObjects[0];
	                    chartDataManager.registerSymbol(self.chartObj, tickerObjects);
	                    self.tickerObjects = tickerObjects;
	                    var frequency = self.config.frequency;
	                    var interval = self.config.interval;
	                    if (self.isMutualFund(self.mainTickerObject)) {
	                        if (!isNaN(self.config.frequency)) {
	                            frequency = "d";
	                        }
	                        if (/\d+D$/.test(self.config.interval)) {
	                            interval = "3M";
	                        }
	                    }
	                    dataAdapter.setFrequency(frequency);
	                    dataAdapter.setDateRange(self.getDateRange(interval));
	                    self.config.currencyCode = self.mainTickerObject['currency'] || "";
	                    self.config.currencySymbol = Util.getCurrency(self.config.currencyCode, "symbol") || self.config.currencyCode;
	                    self.config.yaxis.numberFormat = function (d, ticks) {
	                        if (ticks && d == ticks[ticks.length - 1]) {
	                            if (self.config.currency == 'code') {
	                                return self.config.currencyCode + ' ' + numberFormat(d);
	                            } else if (self.config.currency == 'symbol') {
	                                return self.config.currencySymbol + numberFormat(d);
	                            }
	                        } else {
	                            return numberFormat(d);
	                        }
	                    };
	                    self.setExchangeName();
	                    if (!self.svgplot) {
	                        self.initPlot();
	                    }
	
	                    self._execCallBack('onTickerAccepted', tickerObjects[0]);
	                    if (triggerMainTickerChange) {
	                        self._execCallBack('onMainTickerChanged', tickerObjects[0]);
	                    }
	                    self.fetchData();
	                });
	            },
	            initPlot: function () {
	                var self = this;
	                self.svgplot = morningstar.components['markets-components-svgplot'].createComponent({
	                    element: this.$container,
	                    initialConfiguration: {
	                        component: {
	                            //id: QSAPI.Util.IdProducer.getId() + "_svgplot_unqiue_id",
	                            configuration: this.config,
	                            callbacks: {
	                                onDrawEnd: function (result) {
	                                    var lastPriceDate = self.getLastPriceAndDate(self.mainData, result.locale);
	                                    self._execCallBack('onDrawEnd', {
	                                        lastClosePrice: lastPriceDate.price,
	                                        currencyCode: self.config.currencyCode,
	                                        currencySymbol: self.config.currencySymbol,
	                                        endDate: lastPriceDate.endDate,
	                                        exchangeName: self.exchangeName
	                                    });
	                                }
	                            }
	                        }
	                    }
	                });
	            },
	            getLastPriceAndDate: function (data, locale) {
	                var lastPriceAndDate = {};
	                if (data && data.length) {
	                    for (var i = data.length - 1; i >= 0; i--) {
	                        if (!isNaN(data[i].close)) {
	                            lastPriceAndDate.price = numberFormat(data[i].close);
	                            lastPriceAndDate.endDate = locale.timeFormat('mmmdd,yyyy')(data[i].date);
	                            break;
	                        }
	                    }
	                }
	                return lastPriceAndDate;
	            },
	            resize: function (w) {
	                this.config.width = w;
	            },
	            setExchangeName: function () {
	                var exchangeNameMap = QSAPI.DataManager._getExchangeNameMap();
	                this.exchangeName = exchangeNameMap[this.mainTickerObject.listMarket] || "";
	            },
	            getDateRange: function (interval) {
	                var dateRange = [];
	                if (this.config.dateRange && this.config.dateRange.length === 2) {
	                    if (typeof this.config.dateRange[0] === 'string') {
	                        dateRange[0] = new Date(this.config.dateRange[0]);
	                    }
	                    if (typeof this.config.dateRange[1] === 'string') {
	                        dateRange[1] = new Date(this.config.dateRange[1]);
	                    }
	                } else if (interval) {
	                    dateRange = this.getDateRangeByInterval(interval);
	                }
	                return dateRange;
	            },
	            isMutualFund: function (tickerObj) {
	                var type = tickerObj.type;
	                var mType = tickerObj.mType;
	                var isFundType = false;
	                if (tickerObj.tsfund && tickerObj.tenforeCode && tickerObj.tenforeCode.indexOf('9999') > -1 || (tickerObj.tsfund && !tickerObj.tenforeCode)) {
	                    isFundType = true;
	                }
	                return isFundType || mType === "FO" || (type == 8 && (!mType || mType == "SA")) || tickerObj.isCustomFund;
	            },
	            getDateRangeByInterval: function (intervalType) {
	                var today = new Date();
	                var y = today.getFullYear(),
	                    m = today.getMonth(),
	                    d = today.getDate();
	                var startDate;
	                switch (intervalType) {
	                    case "1D":
	                        dataAdapter.setDays(1);
	                        startDate = new Date(y, m, d);
	                        break;
	                    case "5D":
	                        dataAdapter.setDays(5);
	                        startDate = new Date(y, m, d - 5);
	                        break;
	                    case "15D":
	                        dataAdapter.setDays(5);
	                        startDate = new Date(y, m, d - 15);
	                        break;
	                    case "1M":
	                        startDate = new Date(y, m - 1, d);
	                        break;
	                    case "3M":
	                        startDate = new Date(y, m - 3, d);
	                        break;
	                    case "6M":
	                        startDate = new Date(y, m - 6, d);
	                        break;
	                    case "YTD":
	                        startDate = new Date(y, 0, 1);
	                        break;
	                    case "1Y":
	                        startDate = new Date(y - 1, m, d);
	                        break;
	                    case "3Y":
	                        startDate = new Date(y - 3, m, d);
	                        break;
	                    case "5Y":
	                        startDate = new Date(y - 5, m, d);
	                        break;
	                    case "10Y":
	                        startDate = new Date(y - 10, m, d);
	                        break;
	                    case "Max":
	                        startDate = new Date(y - 15, m, d);
	                        break;
	                    case IntervalTypes.Max:
	                        startDate = config.compareNewstartDate || config.maxRangeStartDate;
	                        break;
	                }
	                return [startDate, today];
	            },
	            getPriceType: function (tickerObjects) {
	                var priceType = PriceType.Default;
	                if (tickerObjects.length > 1) {
	                    priceType = PriceType.Growth;
	                } else if (this.chartType == ChartType.FundChart) {
	                    priceType = PriceType.Nav;
	                }
	                return priceType;
	            },
	            fetchData: function () {
	                var self = this;
	                self.setChartType();
	                dataAdapter.setPriceType(self.getPriceType(self.tickerObjects));
	                dataAdapter.fetchData(self.tickerObjects, self.chartObj, function (data) {
	                    self.onDataArrived(data);
	                });
	            },
	            setChartType: function () {
	                var mainTickerObject = this.mainTickerObject;
	                if (mainTickerObject.type === 20) {
	                    this.chartType = ChartType.ForexChart;
	                } else if ((common.isMutualFund(mainTickerObject) || common.isPortfolio(mainTickerObject))) {
	                    this.chartType = ChartType.FundChart;
	                } else if (common.isCommodity(mainTickerObject)) {
	                    this.chartType = ChartType.CommodityChart;
	                } else {
	                    this.chartType = ChartType.StockChart;
	                }
	            },
	            onDataArrived: function (data) {
	                this.seriesList = [];
	                if (data[0].tickerObject.gkey !== this.mainTickerObject.gkey || this.mainTickerObject.symbol !== this.mainTicker) {
	                    return;
	                }
	                for (var i = 0; i < data.length; i++) {
	                    var series = {};
	                    series['data'] = data[i].Price.data;
	                    this.mainData = series['data'];
	                    series['graphType'] = this.config.chartStyle;
	                    this.seriesList.push(series);
	                }
	
	                if (this.mainData.length == 0) {
	                    this.svgplot && this.svgplot.setProperty('data', this.seriesList);
	                    this.showDataNotAvailable();
	                } else {
	                    this.hideDataNotAvailable();
	                    this.svgplot && this.svgplot.setProperty('data', this.seriesList);
	                }
	
	                this._execCallBack('onLoad');
	            },
	            unregisterChartTickers: function () {
	                chartDataManager.unregisterSymbol(this.chartObj, this.tickerObjects);
	            },
	            showDataNotAvailable: function () {
	                this.$container.empty();
	                this.svgplot && this.svgplot.destroy();
	                this.svgplot = null;
	                var nodata = labels.getLabel(this.config.locale, "datanotavalible");
	                this.$dataNotAvailable = $("<p>" + nodata + "</p>")
	                    .appendTo(this.$container)
	                    .addClass("markets-components-minichart-data-not-available");
	                this._execCallBack('onNodata');
	
	            },
	            hideDataNotAvailable: function () {
	                if (this.$dataNotAvailable) {
	                    this.$dataNotAvailable.remove();
	                }
	            },
	            _changeMainTicker: function (symbol) {
	                this.unregisterChartTickers();
	                var self = this;
	                self.mainTicker = symbol;
	
	                self.seriesList = [];
	                self.init(true);
	            },
	            _execCallBack: function (name, args) {
	                if ($.isFunction(this.cb[name])) {
	                    args = args || {};
	                    this.cb[name].call(this, args);
	                }
	            }
	
	        };
	        return chart;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1)], __WEBPACK_AMD_DEFINE_RESULT__ = function(morningstar) {
	    'use strict';
	    var QSAPI = morningstar.components['markets-components-core'];
	    var $ = QSAPI.$;
	    var Util = QSAPI.Util;
	    var dateUtil = QSAPI.Widget.Chart.Util;
	    var chartDataManager = QSAPI.DataManager.Chart;
	
	    var model = function() {
	        var frequency = 'd',
	            dateRange, priceType, isPreAfter = false,
	            days = -1;
	
	        function formatPrice(data) {
	            if (!data) {
	                return;
	            }
	            var formatData = [];
	            for (var i = 0; i < data.length; i++) {
	                var d = data[i];
	                var tickerObject = d.tickerObject;
	                var priceData = d.price && d.price.data ? d.price.data : [];
	                var lastTradeTime = d.price &&  d.price.lastTradeTime;
	                var jsonObject = {
	                    tickerObject: tickerObject,
	                }
	                jsonObject["Price"] = {
	                    'timeDiff': d.price && d.price.timeDiff ? d.price.timeDiff : 0,
	                    'epos': d.price && d.price.epos ? (+d.price.epos) : 0,
	                    'spos': d.price && d.price.spos ? (+d.price.spos) : 0,
	                    'data': []
	                };
	                for (var j = 0, jl = priceData.length, pd, vd, temp; j < jl; j++) {
	                    pd = priceData[j];
	                    var previousData = null;
	                    if (isNaN(pd[1]) && j > 0 && lastTradeTime > pd[8]) {
	                        previousData = jsonObject["Price"].data[j - 1];
	                    }
	
	                    temp = {
	                        'index': pd[0],
	                        'open': previousData ? previousData.open : pd[4],
	                        'high': previousData ? previousData.high : pd[2],
	                        'low': previousData ? previousData.low : pd[3],
	                        'close': previousData ? previousData.close : pd[1],
	                        'upFlag': pd[5],
	                        'updatedId': pd[pd.length - 2],
	                        'date': dateUtil.toDateFromIndexOrTick(pd[pd.length - 1], 1),
	                        'dateIndex': pd[pd.length - 1]
	                    };
	
	                    if (isIntraday()) {
	                        temp.date = new Date(temp.dateIndex);
	                        temp['fillFlag'] = pd[6]
	                    }
	                    jsonObject["Price"].data.push(temp);
	                }
	                formatData.push(jsonObject);
	            }
	            return formatData;
	        }
	
	        function isIntraday() {
	            return !isNaN(frequency);
	        }
	        var dataAdapter = {
	            ready: false,
	            init: function() {
	                if (!dataAdapter.ready) {
	                    this.ready = true;
	                }
	            },
	            createTickerObjects: function(tickers, callback) {
	                var deferred = $.Deferred();
	                QSAPI.TickerFactory.create(tickers, {
	                    onSuccess: function(tickerObjects) {
	                        deferred.resolve(tickerObjects);
	                    },
	                    onFalure: function() {
	                        deferred.resolve();
	                    }
	                });
	                return deferred;
	            },
	            fetchData: function(tickerObjects, chartObj, callback) {
	                var self = this;
	                var infoList = [];
	                var updateLastAccessTime = tickerObjects[0] && tickerObjects[0].updateLastAccessTime;
	                for (var i = 0; i < tickerObjects.length; i++) {
	                    var info = {
	                        tickerObject: tickerObjects[i],
	                        datapoints: {
	                            p: priceType
	                        }
	                    };
	                    if (isIntraday(frequency)) {
	                        info.days = days;
	                        info.updateLastAccessTime = updateLastAccessTime;
	                    }
	                    infoList.push(info);
	                }
	                var startIndex = dateUtil.toDateIndex(dateRange[0]);
	                var endIndex = dateUtil.toDateIndex(dateRange[1]);
	                if (isIntraday(frequency)) {
	                    chartDataManager.getIntradayData(infoList, frequency, 0, 0, function(data) {
	                        callback(formatPrice(data));
	                    }, isPreAfter, chartObj.id);
	                } else {
	                    chartDataManager.getHistoricalData(infoList, frequency, startIndex, endIndex, function(data) {
	                        callback(formatPrice(data));
	                    }, true);
	                }
	            },
	            setPriceType: function(type) {
	                priceType = type;
	            },
	            setFrequency: function(fre) {
	                if (typeof fre != "Number" && !isNaN(parseInt(fre, 10))) {
	                    frequency = parseInt(fre, 10);
	                } else {
	                    frequency = fre;
	                }
	            },
	            setDateRange: function(range) {
	                dateRange = range;
	            },
	            setDays: function(d) {
	                days = d;
	            },
	            formatPrice: formatPrice
	        }
	        return dataAdapter;
	    }
	    return model;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    function isPortfolio(tickerObj) {
	        var mType = tickerObj.mType;
	        return mType === 'PO';
	    }
	
	    function isCommodity(tickerObj) {
	        var mType = tickerObj.mType;
	        return mType === "FU";
	    }
	
	    function isMutualFund(tickerObj) {
	        var type = tickerObj.type;
	        var mType = tickerObj.mType;
	        return type == 8 && (!mType || mType == "FO");
	    }
	    var chartType = {
	        StockChart: "StockChart",
	        ForexChart: "ForexChart",
	        FundChart: "FundChart",
	        CommodityChart: "CommodityChart"
	    };
	    var priceType = {
	        Default: 'price',
	        Nav: 'nav',
	        Growth: 'return'
	    };
	    var util = {
	        isPortfolio: isPortfolio,
	        isCommodity: isCommodity,
	        isMutualFund: isMutualFund,
	        chartType: chartType,
	        priceType: priceType
	    }
	    return util;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	    var Lables = {
	        "datanotavalible": {
	            "en": "Data not available.",
	            "fr": "Donnée non disponible.",
	            "nl": "Data not available.",
	            "no": "Data not available.",
	            "fi": "Data not available.",
	            "pt": "Data not available.",
	            "es": "Data not available.",
	            "it": "Data not available.",
	            "sv": "Data not available.",
	            "de": "Data not available.",
	            "da": "Data not available.",
	            "zh": "数据不存在",
	            "zh-TW": "數據不存在",
	            "zh-HK": "數據不存在",
	            "ja": "データは存在しない"
	        },
	        "lastprice": {
	            "en": "Last Price",
	            "fr": "Dernier cours",
	            "nl": "Vorige waarde",
	            "no": "Siste verdi",
	            "fi": "Viimeinen arvo",
	            "pt": "Último valor",
	            "es": "Último Valor",
	            "it": "Ultimo valore",
	            "sv": "Sista värde",
	            "de": "Letzter Kurs",
	            "da": "Seneste værdi",
	            "zh": "最新值",
	            "zh-TW": "最新值",
	            "zh-HK": "最新值",
	            "ja": "最新の値",
	            "th": "ราคาหุ้น"
	        },
	        "endofdate": {
	            "en": "End of Date data as of",
	            "fr": "Données de fin de la journée au", //need to be replaced
	            "nl": "End of Date data as of",
	            "no": "End of Date data as of",
	            "fi": "End of Date data as of",
	            "pt": "End of Date data as of",
	            "es": "End of Date data as of",
	            "it": "End of Date data as of",
	            "sv": "End of Date data as of",
	            "de": "End of Date data as of",
	            "da": "End of Date data as of",
	            "zh": "收盘价更新于",
	            "zh-TW": "收盤價更新於",
	            "zh-HK": "收盤價更新於",
	            "ja": "終値ベース価格更新日"
	        }
	    };
	    var getLabel = function(locale, key) {
	        var label = "";
	        if (Lables[key]) {
	            var lang = locale.split('-')[0];
	            if(lang === 'jp') {
	                lang = 'ja';
	            }
	            label = Lables[key][locale] || Lables[key][lang] || Lables[key]['en'] || "";
	        }
	        return label;
	    };
	    return {
	        getLabel: getLabel
	    };
	
	}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(1), __webpack_require__(6), __webpack_require__(10), __webpack_require__(8)], __WEBPACK_AMD_DEFINE_RESULT__ = function(morningstar, dataAdapter, legendHtml, labelManager) {
	        'use strict';
	        var QSAPI = morningstar.components['markets-components-core'];
	        var $ = QSAPI.$;
	        var Util = QSAPI.Util;
	        var config;
	        var legend = function(container, option, callbacks) {
	            this.$container = (container.jQuery) ? container : $(container);
	            this.callbacks = callbacks;
	            config = option;
	            this.render();
	        };
	        legend.prototype = {
	            render: function() {
	                this.$container.append(legendHtml());
	                this.$container.find('.markets-components-minichart-legend-text').html(labelManager.getLabel(config.locale, 'lastprice'));
	                this.resize();
	            },
	            resize: function(w, h) {
	                this.$container.height(config.height);
	            },
	            setData: function(data) {
	                this.$container.find('.markets-components-minichart-lastClosePrice').html(data);
	            }
	        };
	        return legend;
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(11);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    return "<div class=\"markets-components-minichart-legend\">\n    <div class=\"markets-components-minichart-label\">\n        <div class=\"markets-components-minichart-legend-symbol\"></div>\n        <div class=\"markets-components-minichart-legend-text\"></div>\n    </div>\n    <div class=\"markets-components-minichart-figure markets-components-minichart-lastClosePrice\"></div>\n</div>";
	},"useData":true});

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	module.exports = __WEBPACK_EXTERNAL_MODULE_11__;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(11);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<div class=\"markets-components-minichart markets-components-minichart--"
	    + alias4(((helper = (helper = lookupProperty(helpers,"skin") || (depth0 != null ? lookupProperty(depth0,"skin") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"skin","hash":{},"data":data,"loc":{"start":{"line":1,"column":71},"end":{"line":1,"column":79}}}) : helper)))
	    + " "
	    + alias4(((helper = (helper = lookupProperty(helpers,"addMuiClassInTopElement") || (depth0 != null ? lookupProperty(depth0,"addMuiClassInTopElement") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"addMuiClassInTopElement","hash":{},"data":data,"loc":{"start":{"line":1,"column":80},"end":{"line":1,"column":107}}}) : helper)))
	    + "\">\n    <main class=\"markets-components-minichart-main\">\n        <div class=\"markets-components-minichart-legend-container\"></div>\n        <div class=\"markets-components-minichart-plot-container\"></div>\n    </main>\n    <footer class=\"markets-components-minichart-footer\"></footer>\n    <div class=\"markets-components-minichart-loading\">\n        <div class=\"markets-components-minichart-loading-item markets-components-minichart-loading__item--1\"></div>\n        <div class=\"markets-components-minichart-loading-item markets-components-minichart-loading__item--2\"></div>\n        <div class=\"markets-components-minichart-loading-item markets-components-minichart-loading__item--3\"></div>\n        <div class=\"markets-components-minichart-loading-item markets-components-minichart-loading__item--4\"></div>\n        <div class=\"markets-components-minichart-loading-item markets-components-minichart-loading__item--5\"></div>\n        <div class=\"markets-components-minichart-loading-item markets-components-minichart-loading__item--6\"></div>\n        <div class=\"markets-components-minichart-loading-item markets-components-minichart-loading__item--7\"></div>\n        <div class=\"markets-components-minichart-loading-item markets-components-minichart-loading__item--8\"></div>\n    </div>\n</div>";
	},"useData":true});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var Handlebars = __webpack_require__(11);
	function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
	module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
	    var helper, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, alias3="function", alias4=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
	        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
	          return parent[propertyName];
	        }
	        return undefined
	    };
	
	  return "<span class=\"markets-components-minichart-footer-text\">"
	    + alias4(((helper = (helper = lookupProperty(helpers,"currency") || (depth0 != null ? lookupProperty(depth0,"currency") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"currency","hash":{},"data":data,"loc":{"start":{"line":1,"column":55},"end":{"line":1,"column":67}}}) : helper)))
	    + " | "
	    + alias4(((helper = (helper = lookupProperty(helpers,"exchange") || (depth0 != null ? lookupProperty(depth0,"exchange") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"exchange","hash":{},"data":data,"loc":{"start":{"line":1,"column":70},"end":{"line":1,"column":82}}}) : helper)))
	    + " | "
	    + alias4(((helper = (helper = lookupProperty(helpers,"label") || (depth0 != null ? lookupProperty(depth0,"label") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"label","hash":{},"data":data,"loc":{"start":{"line":1,"column":85},"end":{"line":1,"column":94}}}) : helper)))
	    + " "
	    + alias4(((helper = (helper = lookupProperty(helpers,"date") || (depth0 != null ? lookupProperty(depth0,"date") : depth0)) != null ? helper : alias2),(typeof helper === alias3 ? helper.call(alias1,{"name":"date","hash":{},"data":data,"loc":{"start":{"line":1,"column":95},"end":{"line":1,"column":103}}}) : helper)))
	    + "</span>";
	},"useData":true});

/***/ })
/******/ ])
});
;
//# sourceMappingURL=markets-components-minichart.js.map